export default __webpack_public_path__ + "img/a455684857f5569107b6961d85462410.svg";